import { render, staticRenderFns } from "./MessengerSyncList.vue?vue&type=template&id=3e350e77&"
import script from "./MessengerSyncList.vue?vue&type=script&lang=js&"
export * from "./MessengerSyncList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports